<template>
  <div class="main-dis">
    <!-- <div>Hii ExecutiveSummary</div> -->
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
    >
      <font-awesome-icon
        icon="fa-solid fa-sync" spin
        size="2x">
      </font-awesome-icon>
      <div style="padding-left:10px;"> Loading Data </div>
    </b-loading>
    <div v-if="!isLoading">
      <section>
        <div class="is-size-3 title-text-style has-text-centered pb-2">Villa Logistic Stat</div>
        <div class="columns is-mobile is-full is-multiline">
          <div
            class="column"
            v-for="(item,i) in showCurrentStat()"
            :key="i"
          >
            <div class="is-size-2">{{item.val}}</div>
            <div>{{item.key}}</div>
          </div>
        </div>
        <div class="is-size-7">Updated at: {{updatedAt}}</div>
      </section>
      <section class="columns is-vcentered is-mobile is-multiline is-centered">
        <div class="column is-4 is-narrow">
          <div class="title-text-style has-text-centered">Over-All Chart</div>
          <over-all-pie-chart
            :chartData="lateCount()"
            :title="'test'"
          />
        </div>
        <div class="column is-8 is-narrow">
          <div class="columns is-mobile is-multiline block">
            <div class="column is-full title-text-style has-text-centered">Driver List</div>
            <div
              class="column"
              v-for="(item,index) in topFiveDriver()"
              :key="index"
            >Top 5 {{tableHeader[index]}} Driver
              <b-table
                :data="item"
                :columns="tableColum[index]"
              ></b-table>
            </div>
          </div>
          <div class="columns is-mobile is-multiline block">
            <div class="column is-full title-text-style has-text-centered">Branch List</div>
            <div
              class="column"
              v-for="(item,index) in topFiveBrachs()"
              :key="index"
            >Top 5 {{tableHeader[index]}} Branch
              <b-table
                :data="item"
                :columns="tableColum[index]"
              ></b-table>
            </div>
          </div>
        </div>
        <div class="column is-size-7">Updated at: {{updatedAt}}</div>
      </section>
      <section>
        <div class="title-text-style has-text-centered pb-2">Success Orders per Hours</div>
        <count-per-hours-chart
          :title="'test-combo'"
          :chartData="hourlyLOTSData"
        />
        <div class="is-size-7">Updated at: {{updatedAt}}</div>
      </section>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import OverAllPieChart from '../components/executiveSummary/OverAllPieChart.vue'
import getDateTimeFormat from '../setting/timeframeFormatt'
import findTopSth from '../setting/findTopSth'
import CountPerHoursChart from '../components/executiveSummary/CountPerHoursChart.vue'
export default {
  components: { OverAllPieChart, CountPerHoursChart },
  name: 'ExecutiveSummary',
  data () {
    return {
      todayTemp: dayjs(),
      isLoading: true,
      tableHeader: ['Success', 'On-Time', 'Late'],
      tableColum: [
        [
          { field: 'name', label: 'Name', centered: true },
          {
            field: 'success',
            label: 'orders',
            centered: true
          }
        ],
        [
          { field: 'name', label: 'Name', centered: true },
          {
            field: 'onTime',
            label: 'orders',
            centered: true
          }
        ],
        [
          { field: 'name', label: 'Name', centered: true },
          {
            field: 'late',
            label: 'orders',
            centered: true
          }
        ]
      ]
    }
  },
  async mounted () {
    this.isLoading = true
    await this.initView()
    // console.log('currentStat >>>', this.showCurrentStat())
    // console.log('summary >>>', this.storeData, this.driverData, this.branchData)
    // console.log('hourlyStat >>>', this.hourlyStat)
  },
  computed: {
    currentStat () {
      return this.$store.getters['currentStat/status']
    },
    updatedAt () {
      return dayjs().format('YYYY-MM-DD HH:00:00')
    },
    storeData () {
      return this.$store.getters['summary/storeData']
    },
    driverData () {
      return this.$store.getters['summary/listDriver']
    },
    branchData () {
      return this.$store.getters['summary/listBranch']
    },
    hourlyLOTSData () {
      return this.$store.getters['summary/hourlyLOTS']
    },
    hourlyStat () {
      return this.$store.getters['summary/hourlyStat']
    }
  },
  methods: {
    async initView () {
      this.$store.commit('summary/clearStoreDetail')
      await Promise.all([
        this.$store.dispatch('currentStat/getStatus'),
        this.$store.dispatch('summary/getStoreDetail', {
          timeframe: getDateTimeFormat('day')
        }),
        this.$store.dispatch(
          'summary/getHourlyLOTS',
          this.todayTemp.format('YYYY-MM-DD')
        ),
        this.$store.dispatch(
          'summary/getHourlyStat',
          this.todayTemp.subtract(8, 'hours').format('YYYY-MM-DDTHH:59:59[Z]')
        )
      ])
      this.isLoading = false
    },
    showCurrentStat () {
      const ret = []
      for (const [key, val] of Object.entries(this.hourlyStat)) {
        if (key === 'issue') {
          ret.push({ key: 'cancelOrder', val: val })
        } else {
          ret.push({ key: key, val: val })
        }
      }
      return ret
    },
    lateCount () {
      const _lateCount = []
      this.storeData.forEach((i) => {
        _lateCount.push(i.lateCount[0])
      })
      return _lateCount
    },
    topFiveDriver () {
      return findTopSth(this.driverData)
    },
    topFiveBrachs () {
      return findTopSth(this.branchData)
    }
  }
}
</script>

<style scoped>
.main-dis {
  margin-bottom: 50px;
  padding: 25px;
}
.title-section {
}
</style>
